module.exports = {"id":"216055","name":"Federico Carrizo","rating":"75","photo":"./data/images/photos/2/216055.png","club":{"name":"Rosario Central","logo":"./data/images/clubs/RosarioCentral.png"},"positions":["MG","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FedericoCarrizo0.json
// module id = 1374
// module chunks = 0